<template>
    <div class="d-flex flex-1 h-100 overflow-auto">
        <v-card class="report-container w-100  p-0" style="border-radius: 12px; margin-bottom: 24px">
            <v-toolbar class="shadow-none" style="flex: unset;" content-class="h-auto">
                <div class="custom-icon-wrapper">
                    <v-icon @click=" backToAdminPage()">custom-icon left-arrow-icon</v-icon>
                </div>
                <v-toolbar-title class="size-16 dark-text">{{ $t("res_Label_CorrespondenceManagement") }}</v-toolbar-title>
            </v-toolbar>

            <div class="border-top p-4 flex-1 overflow-auto">
                <div class="row align-items-start m-0 gap-2">
                    
                    <div class="p-0" style="width: 19%">
                        <label class="label_required mb-1">{{ $t("res_Label_User") }}</label>
                        <div class="with-absolute-button">
                            <StructureUserSelector :showInternalUsers="true" :showExternalUsers="false"
                                :showInternalStructures="false" :showExternalStructures="false"
                                :excludeSelf="false" :isMultiple="false"
                                :selectedStructureUser="filterObject.userName"
                                @structureUserSelectChanged="setUser($event)"
                                addressBook_header="Select User">
                            </StructureUserSelector>
                        </div>
                    </div>

                    <div class="p-0" style="width: 19%">
                        <label class="label_required mb-1">{{ $t("res_Label_Structure")}}</label>
                        <div class="with-absolute-button">
                            <StructureUserSelector :showInternalUsers="false" :showExternalUsers="false"
                                :showInternalStructures="true" :showExternalStructures="false"
                                :excludeSelf="false" :isMultiple="false"
                                :selectedStructureUser="filterObject.structureName"
                                @structureUserSelectChanged="setStructure($event)"
                                addressBook_header="Select Structure">
                            </StructureUserSelector>
                        </div>
                    </div>

                    <div class="p-0" style="width: 19%">
                        <label class="label_required mb-1">{{ $t("res_Label_Status")}}</label>
                        <div class="with-absolute-button">
                            <multiselect class="light-bg add-arrow" v-model="filterObject.statusSelected" label="name" track-by="id" 
                                open-direction="bottom" :options="this.allStatus" :searchable="true"  :loading="false" :internal-search="false" 
                                :clear-on-select="false" :close-on-select="true" :options-limit="300" :max-height="600" 
                                :placeholder="$t('res_Label_Select')" :show-no-results="false" :hide-selected="false" :multiple="false">
                            </multiselect>
                        </div>
                    </div>

                    <div class="p-0" style="width: 19%">
                        <label class="label_required mb-1">{{ $t("res_Label_ReferencenNo")}}</label>
                        <div class="with-absolute-button">
                            <v-text-field :placeholder="$t('res_Placeholder_EnterReference')" 
                                v-model="filterObject.referenceNumber" 
                                type="text" class="search-field m-0 light-bg"></v-text-field>
                        </div>
                    </div>
 
                    <div class="p-0" style="width: 19%">
                        <label class="label_required mb-1">{{ $t("res_Label_Subject")}}</label>
                        <div class="with-absolute-button">
                            <v-text-field :placeholder="$t('res_Placeholder_EnterSubject')" 
                                v-model="filterObject.subject" 
                                type="text" class="search-field m-0 light-bg"></v-text-field>
                        </div>
                    </div>
                </div>

                <div class="mt-2">
                    <v-btn @click="searchCorrepondences()" color="light-blue">{{ $t("res_ButtonText_Search") }}</v-btn>
                    <v-btn @click="reset()" color="mx-2 primary">{{ $t("res_ButtonText_Reset") }}</v-btn>
                </div>

                <hr>

                <div class="tab-content">
                    <div class="panel">
                        <div class="row m-auto">
                            <div :class="{ 'custom-col col-lg-7 col-xl-6 p-0 pr-5': openPreviewPane, 'col-md-12 p-0': !openPreviewPane }">
                                <v-layout column>
                                    <v-flex class="position-relative sm-margin" md12>
                                        <!--table-->
                                        <v-data-table class="position-relative white" disable-sort :headers="headers"
                                            :items="correspondences" :loading="loadingData" loading-text="loading..." :no-data-text="$t('res_Label_NoData')"
                                            :footer-props="{ 'items-per-page-text': 'Items per page' }" caption=""  @click:row="previewCorrespondence"
                                            :class="{'result_available': correspondences.length != 0}" hide-default-footer item-key="documentId"
                                            :items-per-page="pagingData.pageSize" @item-selected="itemSelected" @dblclick:row="openFullView">
                                            <template v-slot:item.subject="{ item }">
                                                <span class="text-limit" v-tooltip="item.subject">{{ item.subject }}</span>
                                            </template>
                                            <template v-slot:item.referenceNumber="{ item }">
                                                <span class="text-limit" v-tooltip="item.referenceNumber">{{ item.referenceNumber }}</span>
                                            </template>
                                            <template v-slot:item.duedate="{ item }">
                                                {{ utils.formatDateTime(item.duedate) }}
                                            </template>
                                            <template v-slot:item.category="{ item }">
                                                <span class="text-limit" v-tooltip="item.category">{{ item.category }}</span>
                                            </template>
                                            <template v-slot:item.status="{ item }">
                                                <v-chip dark v-bind:class=getStatusClass(item)>
                                                    {{ item.status }}
                                                </v-chip>
                                            </template>
                                            <template v-slot:item.recievedDate="{ item }">
                                                {{ utils.formatDateTime(item.recievedDate) }}
                                            </template>
                                                
                                        </v-data-table>
                                        <Pagination :totalCount="pagingData.totalCount" :pageSize="pagingData.pageSize"
                                            :pageIndex="pagingData.pageIndex" @pageIndexChanged="pageIndexChanged"></Pagination>
                                    </v-flex>
                                </v-layout>
                            </div>
                            <div :class="{ 'custom-col col-lg-5 col-xl-6 p-0 py-2': openPreviewPane }" v-if="openPreviewPane">
                                <div class="h-100" style="background: #EFF2F5; border-radius: 12px; position: relative; overflow: hidden" >
                                    <div>
                                        <v-btn class="close-btn d-block bg-white close-viewer " icon @click="closePreview()">
                                            <v-icon>mdi-close</v-icon>
                                        </v-btn>
                                    </div>

                                    <!--viewer section-->
                                    <div v-if="enableAdminPreviewCorrespondence" class=" position-relative viewer-container scrollable-container" style="height: calc(100vh - 176px - 1rem); overflow-y: hidden;">
                                        <div v-if="empty_viewer" class="empty-viewer" style="border-radius: 12px; height: calc(100vh - 176px);">
                                            <img src="/assets/images/icons/template.svg" />
                                            <img src="/assets/images/icons/no_preview.svg" />
                                            <p class="mt-4 weight-400">{{ $t("res_Msgs_NoPreviewAvailable") }}</p>
                                        </div>
                                        <div v-if="!empty_viewer" id="viewer_template" class="h-100" style="border-radius: 12px;">
                                            <iframe id="viewerFrame" :src="viewerFrame" class="w-100"></iframe>
                                        </div>
                                    </div>
                                    
                                    <div class="d-flex justify-content-between align-items-center bottom-action-bar gap-2">
                                        <div class="d-flex gap-2 actions_container1 m-auto">
                                        <v-btn color="light-blue" v-if="enableAdminPreviewCorrespondence && showFullViewBtn" @click="openFullView()">{{ $t("res_ButtonText_Full_View") }}</v-btn>
                                        <v-btn color="light-blue" @click="openVisualTracking()">{{ $t("res_ButtonText_VisualTracking") }}</v-btn>
                                    </div>

                                        <v-menu content-class="viewer-button align-bottom-left" top :offset-y="offset" :close-on-content-click="false">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn v-bind="attrs" v-on="on" class="light-blue more-btn">
                                                    <span>{{ $t("res_MenuItems_MoreActions") }}</span>
                                                </v-btn>
                                            </template>
                                            <v-list class="actions_menu1">
                                               <!-- v-if="utils.ActionsPermission('Archive', this.document , selectedItem.item.id, 0 , 8)"-->

                                                <v-list-item v-if="!isArchived" @click="openCompleteDocumentDialog(selectedItem.item.documentId)">{{ $t("res_ButtonText_Archive") }}</v-list-item>
                                                <v-list-item  @click="reOpenCorrespondence(selectedItem.item.documentId)">{{ $t("res_ButtonText_ReOpen") }}</v-list-item>
                                                <!-- <v-list-item class="hide" @click="reActivateCorrespondence(selectedItem.item.documentId)">{{ $t("res_ButtonText_ReopenDocument") }}</v-list-item> -->
                                                <v-list-item  @click="cancelCorrespondence(selectedItem.item.documentId)">{{ $t("res_ButtonText_Cancel") }}</v-list-item>
                                                <v-list-item @click="viewTransfers(selectedItem.item.documentId)">{{ $t("res_ButtonText_ViewTransfers") }}</v-list-item>
                                                <!-- <v-list-item class="hide" @click="updateCorrespondence(selectedItem.item.documentId)">{{ $t("res_DialogTitle_UpdateDocument") }}</v-list-item> -->
                                                <v-list-item  @click="showSignatories(selectedItem.item.documentId)">{{ $t("res_ButtonText_ShowSignatories") }}</v-list-item>
                                                <v-list-item v-if="selectedItem.item.hasRecordInTemplateSignedBy" @click="fixSign(selectedItem.item.documentId, false)">{{ $t("res_ButtonText_FixSignature") }}</v-list-item>
                                                <v-list-item v-if="selectedItem.item.hasRecordInTemplateSignedBy" @click="fixSign(selectedItem.item.documentId, true)">{{ $t("res_ButtonText_FixSignatureMultiPage") }}</v-list-item>
                                                <!-- <v-list-item class="hide" @click="updateDocumentDialog = true">{{ $t("res_DialogTitle_UpdateDocument") }}</v-list-item> -->
                                            </v-list>
                                        </v-menu>
                                    </div>                            
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <v-dialog v-model="correspondenceDialog" content-class="create-document-dialog fullscreen-dialog corr_dialog" fullscreen v-bind:persistent="nodeId == 1">
                <div id="correspondenceDialogEmptyDiv"></div>
                <CreateDocumentView :documentId="documentId" :transferId="transferId" :viewMode="viewMode" 
                    :delegationId="delegationId" :toEmail="toEmail" :emailCC="emailCC" :closeDialogEvent="closeCorrespondenceDialog" :openedFromNodeId="nodeId" :isArchived="isArchived"/>
            </v-dialog>

            <v-dialog v-model="completeDocumentDialog" content-class="small-dialog" width="500" height="350">
                <v-card>
                    <v-card-title>
                        {{ $t("res_DialogTitle_CompleteNotes") }}
                    </v-card-title>
                    <div class="card-body">
                        <label>{{ $t("res_Msgs_EnterNotes") }} *</label>
                        <v-textarea v-model="completeDocument_noteText" solo></v-textarea>
                    </div>
                    <v-card-actions class="gap-2 sticky-actions">
                        <v-spacer></v-spacer>
                        <v-btn color="light-blue" width="100" @click="completeDocument_noteText = ''; completeDocumentDialog = false;">{{ $t("res_ButtonText_Cancel") }}</v-btn>
                        <v-btn color="primary" width="100" @click="completeDocument()">{{ $t("res_ButtonText_Continue") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="openTransfersDialog" content-class="small-dialog" width="90%" height="80%">
                <v-card>
                    <v-toolbar class="bg-white">
                        <v-card-title class="p-0">{{$t("res_Label_Transfers")}}</v-card-title>
                        <v-spacer></v-spacer>
                        <v-btn class="close-btn light-btn" icon dark @click="closeTransfersDialog">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-data-table class="position-relative white" disable-sort :headers="transfersHeaders"
                        :items="transfers" :loading="loadingData" loading-text="loading..." :no-data-text="$t('res_Label_NoData')"
                        :footer-props="{ 'items-per-page-text': 'Items per page' }" caption="" hide-default-footer>
                        <template v-slot:item.fromUserFullName="{ item }">
                            <span class="text-limit" v-tooltip="item.fromUserFullName">{{ item.fromUserFullName }}</span>
                        </template>
                        <template v-slot:item.toUserFullName="{ item }">
                            <span class="text-limit" v-tooltip="item.toUserFullName">{{ item.toUserFullName }}</span>
                        </template>
                        <template v-slot:item.fromStructureName="{ item }">
                            <span class="text-limit" v-tooltip="item.fromStructureName">{{ item.fromStructureName }}</span>
                        </template>
                        <template v-slot:item.toStructureName="{ item }">
                            <span class="text-limit" v-tooltip="item.toStructureName">{{ item.toStructureName }}</span>
                        </template>
                        <template v-slot:item.createdDate="{ item }">
                            {{ utils.formatDateTime(item.createdDate) }}
                        </template>
                        <template v-slot:item.purpose="{ item }">
                            <span class="text-limit" v-tooltip="item.purpose">{{ item.purpose }}</span>
                        </template>
                        <template v-slot:item.statusId="{ item }">
                            <v-btn v-if="item.statusId == 3" @click="ReOpenTransfer(item.id)" class="primary">Re-open</v-btn>
                            <v-btn v-else @click="CloseTransfer(item.id)" class="primary">Close</v-btn>
                        </template>
                    </v-data-table>
                </v-card>
            </v-dialog>

            <v-dialog v-model="updateDocumentDialog" content-class="small-dialog" width="90%" height="80%">
                <v-card>
                    <v-toolbar class="bg-white">
                        <v-card-title class="p-0">{{$t("res_DialogTitle_UpdateDocument")}}</v-card-title>
                        <v-spacer></v-spacer>
                        <v-btn class="close-btn light-btn" icon dark @click="cancelDocumentUpdateDialog">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <div class="container">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="d-flex justify-content-between align-items-center">
                                    <div>
                                        <label class="label_required">{{ $t("res_Label_Subject") }} *</label>
                                    </div>
                                </div>
                                <v-textarea v-model="document.subject" rows="2" class="light-bg  subject-txt" :placeholder="$t('res_Label_defaultTextValue')"></v-textarea>
                            </div>
                            <div class="col-md-6">
                                <div>
                                    <label>{{ $t("res_Label_Priority") }} *</label>
                                    <div class="with-absolute-button">
                                        <multiselect class="light-bg" v-model="document.priority"
                                            open-direction="bottom" :options="this.priorities" :searchable="true"
                                            :loading="false" :internal-search="false" :clear-on-select="false"
                                            :close-on-select="true" :options-limit="300" :max-height="600"
                                            :show-no-results="false" :hide-selected="false" :multiple="false"
                                            @select="priorityChanged" :placeholder="$t('res_Label_SelectOption')"
                                            label="name" track-by="id"> 
                                        </multiselect>
                                    </div>
                                </div>
                                <div class="mt-2">
                                    <label>{{ $t("res_Label_Privacy") }} *</label>
                                    <div class="with-absolute-button">
                                        <multiselect class="light-bg" v-model="document.privacy" label="name" track-by="id"
                                            open-direction="bottom" :options="privacy_items" :searchable="true"
                                            :loading="loading" :internal-search="false" :clear-on-select="false"
                                            :close-on-select="true" :options-limit="300" :max-height="600"
                                            :show-no-results="false" :hide-selected="false" :multiple="false"
                                            ref="multiselect2" :placeholder="$t('res_Label_SelectOption')">
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <label class="label_required">{{ $t("res_Label_Sender") }} *</label>
                                <div class="with-absolute-button">
                                    <StructureUserSelector  :showInternalUsers="false" :showExternalUsers="false"
                                        :showInternalStructures="document.categoryId != 1"
                                        :showExternalStructures="document.categoryId == 1" :excludeSelf="true"
                                        :isMultiple="false" :selectedStructureUser="document.sender"
                                        @structureUserSelectChanged="documentSenderSelectedChange" :addressBook_header="$t('res_Label_SelectSender')">
                                    </StructureUserSelector>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <label class="label_required">{{ $t("res_Label_Recipient") }} *</label>
                                <div class="d-flex align-items-center">
                                    <div class="flex-1 with-absolute-button">
                                        <StructureUserSelector :showInternalUsers="false" :showExternalUsers="false"
                                            :showInternalStructures="document.categoryId == 3" :showExternalStructures="document.categoryId == 2"
                                            :excludeSelf="true" :isMultiple="true"
                                            :selectedStructureUsersList="document.recipient_multiple"
                                            @structureUserSelectChanged="documentRecipientMultipleSelectedChange" addressBook_header="Select recipient">
                                        </StructureUserSelector>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                        <div class="col-md-6">
                            <label class="label_required">{{ $t("res_Label_DocumentDate") }} *</label>
                            <v-menu content-class="p-0" v-model="document_date_menu" :close-on-content-click="false"
                                :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="formattedDate" label="" readonly v-bind="attrs" v-on="on"
                                        solo append-icon="mdi-calendar">
                                        <template v-slot:append>
                                            <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker v-model="document.date" @input="document_date_menu = false"
                                    :max="nowDate"></v-date-picker>
                            </v-menu>
                        </div>
                            <div class="col-md-6">
                                <label class="label_required">{{ $t("res_Label_DueDate") }} *</label>
                                <v-menu content-class="p-0" v-model="document_due_date_menu" :close-on-content-click="false"
                                    :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="formattedDueDate" label="" readonly v-bind="attrs" v-on="on"
                                            solo append-icon="mdi-calendar">
                                            <template v-slot:append>
                                                <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                                            </template>
                                        </v-text-field>
                                    </template>
                                    <v-date-picker v-model="document.dueDate" @input="document_due_date_menu = false"
                                        :min="nowDate"></v-date-picker>
                                </v-menu>
                            </div>
                        </div>
                        <div class="row p-3">
                            <div class="col-6">
                                <v-btn @click="applyChanges()" class="primary">{{ $t("res_ButtonText_ApplyChanges") }}</v-btn>
                            </div>
                        </div>
                    </div>
                    
                </v-card>
            </v-dialog>
            
            <v-dialog v-model="viewManageSignersDialog" content-class="tracker-container dialog with-sticky-actions bg-white"
                width="80%">
                <div class="dialog-body">
                    <ManageSigners :documentId="documentId" :dialogModelShow="viewManageSignersDialog"
                        @closeSignersDialog="closeSignersDialog"></ManageSigners>
                </div>
            </v-dialog>

        </v-card>
    </div>
</template>

<script>
    import axios from 'axios'
    import constants from '@/assets/js/constants'
    import Multiselect from 'vue-multiselect'
    import ManageTransfers from '@/components/ManangeTransfers.vue'
    import ManageSigners from '@/components/ManageSigners.vue'
	import * as utils from '@/assets/js/common.js'
    import Pagination from '@/components/Pagination.vue'
    import StructureUserSelector from '@/components/StructureUserSelector.vue'
    import TransferNotesIcon from '@/components/TransferNotesIcon.vue'
    import CreateDocumentView from '@/views/CreateDocumentView.vue'
    import router from '@/router/index.js'

    export default {
        name: 'ManageCorrespondences',
        components: { Multiselect, ManageTransfers, ManageSigners, Pagination, StructureUserSelector, TransferNotesIcon, CreateDocumentView },
        data() {
            return {              
                utils:utils,
                constants:constants,
                loading: false,
                visualTrackingDialog: false,
                viewManageSignersDialog: false,
                updateDocumentDialog: false,
                document_date_menu: false,
                document_due_date_menu: false,
                due_date_menu: false,
                documentId: 0,
                document: {
                    categoryId: 0,
                    sender: {},
                    sender_designated_person: {},
                    recipient_single: {},
                    recipient_single_designated_person: {},
                    recipient_multiple: [],
                    recipient_multiple_designated_person: [],
                    cc: [],
                    send_after_sign:[],
                    priority: {},
                    privacy: {},
                    importance: {},
                    externalReferenceNumber: '',
                    date: '',
                    subject: '',
                    dueDate: '',
                    translatedSubject: '',
                    keywords: '',
                    otherAttachments: '',
                    signers: [],
                    formData: {},
                    purposeId: 0,
                    SendingEntity: { },
                    secretForward: false,
                    purposeIdBeforeRevoke: 0,
                    // for ADFD
                    outputGroup: '',
                    output: '',
                    country: '',
                    project: '',
                    showProjectGroup: false
                },
                correspondences: [],
                priorities: [],
                structures: [],
                loadingData: false,
                selectedRow: 0,
                subject: '',
                trackingFrameSrc: '',
                headers: [
                    { text: 'Id',               value: 'id',                sortable: false,     align: ' d-none'},
                    { text: this.$t('res_Label_Subject'),               value: 'subject',           sortable: false },
                    { text: this.$t('res_MenuItems_ReferenceNumber'),   value: 'referenceNumber',   sortable: false },
                    { text: this.$t('res_Label_DueDate'),               value: 'duedate',           sortable: true  },
                    { text: this.$t('res_Label_Category'),              value: 'category',          sortable: false },
                    { text: this.$t('res_Label_Status'),                value: 'status',            sortable: false },
                    { text: this.$t('res_GridHeaders_Recieved'),        value: 'recievedDate',      sortable: false },
                ],
                transfersHeaders: [
                    { text: 'Id',               value: 'id',                sortable: false,     align: ' d-none'},
                    { text: this.$t('res_GridHeaders_FromUser'),        value: 'fromUserFullName',  sortable: false },
                    { text: this.$t('res_GridHeaders_ToUser'),          value: 'toUserFullName',    sortable: false },
                    { text: this.$t('res_GridHeaders_FromStructure'),   value: 'fromStructureName', sortable: true  },
                    { text: this.$t('res_GridHeaders_ToStructure'),     value: 'toStructureName',   sortable: false },
                    { text: this.$t('res_GridHeaders_CreatedDate'),     value: 'createdDate',       sortable: false },
                    { text: this.$t('res_Label_Purpose'),               value: 'purpose',           sortable: false },
                    { text: this.$t('res_GridHeaders_Actions'),         value: 'statusId',            sortable: false },
                ],
                dateFormat: window.dateFormatForExternlUse,
                pagingData: {
                    pageSize: 10,
                    pageIndex: 0,
                    totalCount: 0
                },
                allStatus:[],
                
                filterObject:{
                    userName: { id: 0, name: ''},
                    structureName: { id: 0, name: ''},
                    statusSelected: { id: 0, name: '' },
                    referenceNumber: '',
                    subject: ''
                },
                empty_viewer: true,
                openPreviewPane: false,
                showFullViewBtn: false,
                viewerFrame : '',
                selectedItem: {},
                delegationId: 0,
                correspondenceDialog: false,
                transferId: 0,
                viewMode: 'readonly',
                toEmail: "",
                emailCC: "",
                completeDocumentDialog: false,
                completeDocument_noteText: '',
                transfers: [],
                openTransfersDialog: false,
                formattedDate: '',
                formattedDueDate: '',
                document_date_menu: false,
                document_due_date_menu: false,
                nowDate: new Date().toISOString().slice(0, 10),
                priority_items: [],
                privacy_items: [],
                user_structures: [],
                user_structure: {},
                 isArchived:false,
            };
        },
        props: {
            nodeId: { type: Number, default: 2 }
        },
        methods:
        {
            searchCorrepondences()
            { 
                {
                    window.showLoading();
                    axios.get(constants.baseApiUrl + `Search/GetFilteredCorrespondences?userId=${this.filterObject.userName.id}&structureId=${this.filterObject.structureName.id}&statusId=${this.filterObject.statusSelected.id}&referenceNumber=${this.filterObject.referenceNumber}&subject=${this.filterObject.subject}&pageSize=${this.pagingData.pageSize}&pageIndex=${this.pagingData.pageIndex}`)
                    .then(res => { 
                        this.correspondences = [];
                        this.correspondences = res.data.data;
                        this.pagingData.totalCount = res.data.totalCount;
                    })
                    .catch(err => console.warn(err))
                    .finally(() => window.hideLoading())
                }
            },
            searchCorrepondence() 
            {
                if(this.subject == "" && this.ReferenceNumber == "")
                {
                    window.showAlert("res_Msgs_EmptySearch", 'warning')
                }
                else
                { 
                    axios.get(constants.baseApiUrl + 'Search/GetAllCorrespondencesByFilter?getCountOnly=false&subject=' 
                        + this.subject + "&referenceNumber=" + this.ReferenceNumber, { headers: constants.headers })
                        .then(res => 
                        {
                            if(res.data.result.length > 0)
                            {
                               this.correspondences = res.data.result;

                               axios.get(constants.baseApiUrl + 'Search/GetAllCorrespondencesByFilter?getCountOnly=true&subject=' 
                                    + this.subject + "&referenceNumber=" + this.ReferenceNumber, { headers: constants.headers })
                                    .then(res => 
                                    {
                                        if(res.data.result.length > 0)
                                        {
                                           this.pagingData.totalCount = parseInt(res.data.result[0].rowsCount);
                                        }
                                    })
                                    .catch(err => console.warn(err))
                                }
                        })
                        .catch(err => console.warn(err))
                }
            },
            asyncFindStructure(query)
            {
                this.structures = [];
                var methodUrl = 'StructureUser/search?showUsers=false&showInternalStructures=true' +
                    '&showExternalStructures=false&search=';

                axios.get(constants.baseApiUrl + methodUrl + query, { headers: constants.headers })
                    .then(res => this.structures = res.data)
                    .catch(err => console.warn(err))
            },
            pageIndexChanged(pagingData) {
                this.pagingData.pageSize = pagingData.pageSize;
                this.pagingData.pageIndex = pagingData.pageIndex;

                this.searchCorrepondences();
            },
            CapitalizeFirstLetter(string) 
			{
				return utils.CapitalizeFirstLetter(string)
			},
            GetMultiSelectSubHeaderDisplay(options)
            {
                return utils.GetMultiSelectSubHeaderDisplay(options)
            },
            closeSignersDialog()
            {
                this.viewManageSignersDialog = false;
            },
            cancelDocumentUpdateDialog()
            {
                this.updateDocumentDialog = false;
            },
            showSignatories(documentId)
            {
                this.documentId = documentId;
                this.viewManageSignersDialog = true;
            },
            returnToDraft(documentId)
            {
                axios.get(constants.baseApiUrl + 'Document/ReturnToDraft?documentId='+
                    documentId, { headers: constants.headers })
                        .then(res => 
                        {
                            if(res.data != null)
                            {
                                this.searchCorrepondences();
                                window.showAlert('res_Msgs_ReturnToDraft', 'success')
                            }
                        })
                        .catch(err => console.warn(err))
            },
            cancelCorrespondence(documentId)
            {
                  window.showInformation(
                  this.$t("res_Msg_DeleteConfirmation"),
                  this.$t("res_Msgs_CloseCorrespondenceConfirmation"),
                () => {
                 axios.get(constants.baseApiUrl + 'Document/CancelCorrespondence?documentId=' +
                     documentId, { headers: constants.headers })
                        .then(res =>{
                            if(res.data != null){
                                this.searchCorrepondences();
                                window.showAlert('res_Msgs_CorrespondenceCanceled', 'success')
                            }
                        })
                        .catch(err => console.warn(err))
                }
            );
            },
            updateCorrespondence(documentId)
            {
                this.documentId = documentId;
                this.priorities = constants.priorities;
                this.getDocumentWithTransfer();
                this.updateDocumentDialog = true;
            },
            reActivateCorrespondence(documentId)
            {
                window.showLoading()
                axios.get(constants.baseApiUrl + 'Document/ReActivateCorrespondence?documentId=' + 
                    documentId, { headers: constants.headers })
                    .then(res => 
                    {
                        if(res.data == 1){
                        window.showAlert('res_Msgs_OpenedCorrespondence','warning')
                        }else if(res.data == 0){
                            window.showAlert('res_Msgs_ErrorOccured', 'warning')
                        }else{
                            window.showAlert('res_Msgs_CorrespondenceOpen', 'success')
                            this.searchCorrepondences();
                        }
                    })
                    .catch(err => console.warn(err))
                    .finally(window.hideLoading())
            },
            reOpenCorrespondence(documentId)
            {  
                window.showInformation(
                  this.$t("res_Msg_DeleteConfirmation"),
                  this.$t("res_Msgs_ReopenCorrespondenceConfirmation"),
                () => {
                
                window.showLoading()

                axios.get(constants.baseApiUrl + 'Document/ReOpenCorrespondence?documentId=' + documentId ,{ headers: constants.headers })
                    .then(res => {  
                        if(res.data == 1){
                            window.showAlert('res_Msgs_OpenedCorrespondence','warning')
                        }else if(res.data == 0){
                            window.showAlert('res_Msgs_ErrorOccured', 'warning')
                        }else{
                            window.showAlert('res_Msgs_CorrespondenceOpen', 'success')
                            this.searchCorrepondences();
                        }
                 })
                .catch(err => console.warn(err))
                .finally(window.hideLoading())
                });
            },
            openVisualTracking( )
            { 
                //this.visualTrackingDialog = true 
                var lang = localStorage.getItem('lang')
                lang = ((lang == null || lang == undefined) ? 'en' : lang); 
                window.setVisualTrackingData( this.selectedItem.item.documentId);
                this.trackingFrameSrc = "../resources/VisualTracking/VisualTracking.html?lang=" + lang + "&r=" + new Date().getTime()
                window.open(this.trackingFrameSrc,"_blank");
            },
            reset() 
            {
                this.filterObject = {
                    userName: { id: 0, name: ''},
                    structureName: { id: 0, name: ''},
                    statusSelected: { id: 0, name: '' },
                    referenceNumber: '',
                    subject: ''
                }
            },
            prepareStatusForSelect(){
                axios.get(constants.baseApiUrl + 'Lookups/get-all-Statuses')
                        .then(res => 
                        {
                            this.allStatus = res.data
                        })
                        .catch(err => console.log(error))
            },
            setUser(selectedUserItem) {
                if (selectedUserItem != null && selectedUserItem != undefined) {
                    this.filterObject.userName = selectedUserItem;
                    this.filterObject.userName.id = selectedUserItem.id.split('-')[0];
                }
            },
            setStructure(item) {
                this.filterObject.structureName = item;
            },
            previewCorrespondence(item, row) 
            { 
                this.selectedItem = { 'item': item, 'value': true }
                this.openPreviewPane = true 
                this.showFullViewBtn = (item.transferId == null || item.transferId <= 0 ? false : true);
                if (item.attachmentId == null || item.attachmentId == undefined)
                {
                    this.empty_viewer = true
                }
                else
                {
                    if (this.selectedItem.item.statusId != 1) // Draft
                    {  
                    this.CheckIfTransferArchived(this.selectedItem.item.transferId);
                    }

                    this.empty_viewer = false;
                    window.setViewerData(item.attachmentId , item.documentId);
                    this.viewerFrame = '/resources/viewer/viewer.html?lang='+ this.$i18n.locale +  '&defaultScale=page-fit&pageMode=view' + 
                            '&viewerMode=collapsed&r=' + new Date().getTime()        
                }


            },
            closePreview() 
            {
                this.selectedItem = {}
                this.openPreviewPane = false
            },
            CheckIfTransferArchived(id){
                
                //window.showLoading();

                axios.get(constants.baseApiUrl + `Transfer/CheckIfTransferArchived?transferId=${id}`)
                .then(res => {
                   var archived=res.data;
                   this.isArchived=res.data;
                })
                .catch(err => console.warn(err))
                .finally(() => window.hideLoading());
            },
            openFullView()
            {
                if(!this.enableAdminPreviewCorrespondence || !this.showFullViewBtn){
                    return
                }
                //  Draft = 1, Inbox = 2, Sent = 6, Archived = 8, Follow-up = 9
                this.viewMode = 'readonly' // edit
                var item = this.selectedItem.item
                if (item.statusId == 1) // Draft
                { 
                    this.delegationId = 0
                    this.documentId = item.documentId
                    this.correspondenceDialog = true
                }
                else
                { 
                   
                    this.CheckIfTransferArchived(item.transferId);
                    
                    this.delegationId = 0
                    this.transferId = item.transferId
                    this.documentId = item.documentId
                    this.correspondenceDialog = true
                    setTimeout(() => {
                        document.getElementById('correspondenceDialogEmptyDiv').parentElement.parentElement.classList.add('transparentBg');
                    }, 10);
                }
       
                if(this.nodeId == 9){
                    this.toEmail=item.sentToEmail
                    this.emailCC=item.sentToManagerEmail
                }
                
                this.closePreview();
            },
            itemSelected(item, value) 
            { 
                if (item.value == true)
                {
                    this.selectedItem = item;

                    //check if transfer is archived
          
                    if (this.selectedItem.item.statusId != 1) // Draft
                    {  
                    this.CheckIfTransferArchived(this.selectedItem.item.transferId);
                    }
               
                }
                else
                {
                    this.selectedItem = {}
                }
            },
            closeCorrespondenceDialog() 
            {
                this.delegationId = 0;
                this.documentId = 0;
                this.transferId = 0;
                this.correspondenceDialog = false;
            },
            openCompleteDocumentDialog() {
                this.completeDocument_noteText = '';
                this.completeDocumentDialog = true;
            },
            completeDocument() {
                if (this.completeDocument_noteText.trim().length == 0) {
                    window.showAlert('res_Msgs_FillRequired', 'warning')
                    return;
                }

                window.showLoading()
                axios.get(constants.baseApiUrl + 'Document/CheckUserHavePermissionOnDocument?documentId=' + this.selectedItem.item.documentId)
                    .then(res => {
                        if (res.data == 1) {
                            var body = { documentId: this.selectedItem.item.documentId, transferId: this.selectedItem.item.transferId, instructions: this.completeDocument_noteText };
                            axios.post(constants.baseApiUrl + 'Document/CompleteDocument', body, { headers: constants.headers })
                                .then(res => {
                                    window.showAlert('res_Msgs_DocumentCompletedSuccess', 'success')
                                    this.completeDocumentDialog = false;
                                    this.refreshPage()
                                })
                                .catch(error => console.log(error))
                                .finally(() => window.hideLoading())
                        }
                        else {
                            window.hideLoading();
                            window.showAlert('res_Msgs_DocumentNotArchived', 'warning')
                        }
                    })
                    .catch(error => {
                        console.log(error)
                        window.hideLoading()
                        this.completeDocumentDialog = false
                    })
            },
            getStatusClass(item) 
            {
                if(constants.statusesEnum.Completed.value == item.statusId)
                    return constants.statusesEnum.Completed.data().classColor;

                return '';
            },
            viewTransfers(documentId){
                if (documentId == 0) return
                this.documentId = documentId
                this.openTransfersDialog = true;
                this.transfers = [];


                axios.get(constants.baseApiUrl + 'Transfer/GetTransfersListByDocumentId?documentId=' + documentId)
                    .then(response => {
                        this.transfers = response.data;
                })
                .catch(error => this.handleError(error))
            },
            closeTransfersDialog(){
                this.openTransfersDialog = false;
            },
            ReOpenTransfer(id){
                window.showLoading();
                axios.post(constants.baseApiUrl + `Transfer/ToggleTransferStatus?transferId=${id}&newStatusId=${1}`)
                .then(res => {
                    this.viewTransfers(this.documentId);
                })
                .catch(err => console.warn(err))
                .finally(() => window.hideLoading());
            },
            CloseTransfer(id){
                window.showLoading();
                axios.post(constants.baseApiUrl + `Transfer/ToggleTransferStatus?transferId=${id}&newStatusId=${3}`)
                .then(res => {
                    this.viewTransfers(this.documentId);
                })
                .catch(err => console.warn(err))
                .finally(() => window.hideLoading())
            },
            priorityChanged(item) 
            {
                let today = new Date(); // create a new Date object with today's date
                let daysLater1 = new Date(today.getTime() + 15 * 24 * 60 * 60 * 1000); // add 15 days to the current date
                let daysLater2 = new Date(today.getTime() + 7 * 24 * 60 * 60 * 1000); // add 7 days to the current date
                let daysLater3 = new Date(today.getTime() + 2 * 24 * 60 * 60 * 1000); // add 2 days to the current date
                if (this.document.date=='' || this.document.date==null || this.document.date==undefined ) {
                    this.document.date=  new Date().toISOString().slice(0, 10);
                }
                if (item.id == 1)
                    this.document.dueDate = daysLater1.toISOString().slice(0, 10)
                else if (item.id == 2)
                    this.document.dueDate = daysLater2.toISOString().slice(0, 10)
                else if (item.id == 3)
                    this.document.dueDate = daysLater3.toISOString().slice(0, 10)
            },
            fillDocumentDataForEdit(item)
            {
                this.document.categoryId = item.categoryId
                this.document.referenceNumber = item.referenceNumber
                this.document.createdDate = item.createdDate
                this.document.canSign = item.canSign
                this.document.secretForward = item.SecretForward

                if (item.createdDate != null && item.createdDate != undefined) {
                    this.document.date = item.createdDate
                }

                if (item.sendingEntity != null && item.sendingEntity != undefined) {
            
                    var sendingEntityObj = JSON.parse(item.sendingEntity)
                    this.document.sender = { id: sendingEntityObj.id, name: sendingEntityObj.text, isUser: false }
                    //this.getSenderDesignatedPersons(this.document.sender)
                }
                else
                    this.document.sender = this.defaultSender

                if (item.receivingEntities != null && item.receivingEntities != undefined && item.receivingEntities.length > 0) {
                    var receivingEntitiesObjects = JSON.parse(item.receivingEntities)

                    var recipientItems = [{}]
                    receivingEntitiesObjects.forEach(function (recipient) {
                        recipientItems.push({ id: recipient.id.toString(), name: recipient.text, isUser: false, external: recipient.external })
                    });
                    if (this.document.categoryId == 1) {

                        if (recipientItems.length > 1) { 
                                                    this.document.recipient_single = recipientItems[1]
                        }
                    }
                    else 
                    {
                        this.document.recipient_multiple = recipientItems
                    }
                }
                else
                    this.document.recipient = [{}]

                if (item.carbonCopies != null && item.carbonCopies != undefined && item.carbonCopies.length > 0) {
                    var carbonCopyObjects = JSON.parse(item.carbonCopies)
                    
                    var ccItems = []
                    carbonCopyObjects.forEach(function (cc) {
                        ccItems.push({ id: cc.id, name: cc.text, isUser: (carbonCopyObjects[0].id.lastIndexOf('-') != -1) })
                    });
                    if(ccItems.length > 0){
                        this.document.cc = [{}, ...ccItems];    
                    } 
                    else 
                    {
                        this.document.cc = ccItems
                    }
                }

                if (item.priorityId != null)
                    this.document.priority = this.priority_items.find(x => x.id == item.priorityId)
                else {
                    this.document.priority = this.priority_items[0]
                    this.priorityChanged(this.document.priority)
                }
                if (item.privacyId != null)
                    this.document.privacy = this.privacy_items.find(x => x.id == item.privacyId)
                else
                    this.document.privacy = this.privacy_items[0]

                if (item.importanceId != null)
                    this.document.importance = this.importance_items.find(x => x.id == item.importanceId)
                else
                    this.document.importance = this.importance_items[0]

                if (item.externalReferenceNumber != null)
                    this.document.externalReferenceNumber = item.externalReferenceNumber

                if (item.dueDate != null && item.dueDate != undefined) {
                    this.document.dueDate = item.dueDate
                }

                if (item.subject != null) {
                    this.document.subject = item.subject
                    this.subject = item.subject
                }
                
                var selectedUserStructure = this.user_structures.find(s => s.structureId == item.createdByStructureId)
                if (selectedUserStructure != null) {
                    this.user_structure = selectedUserStructure
                }
                //
                var formDataObj = JSON.parse(item.formData);
                this.document.formData = item.formData;
                if (formDataObj != null && formDataObj.senderDesignatedPerson != '') {
                    var sender_designated_person_ids = formDataObj.senderDesignatedPerson
                    if (sender_designated_person_ids != '' && sender_designated_person_ids != undefined) {
                        utils.defaultGet('Document/GetDesignatedPersonsForSelect?ids=' + sender_designated_person_ids,
                            (res) => { this.document.sender_designated_person = res.data[0] },
                            this.handleError, true);
                    }
                }

                if (formDataObj != null && formDataObj.recipientDesignatedPerson != '') {
                    var recipient_designated_person_ids = formDataObj.recipientDesignatedPerson
                    if (recipient_designated_person_ids != '' && recipient_designated_person_ids != undefined) {
                        if (this.document.categoryId == 1) {
                            this.document.recipient_single_designated_person = {}
                            utils.defaultGet('Document/GetDesignatedPersonsForSelect?ids=' + recipient_designated_person_ids,
                                (res) => {
                                    if (res.data.length > 0)
                                        this.document.recipient_single_designated_person = res.data[0]
                                },
                                this.handleError, true);
                        }
                        else {
                            utils.defaultGet('Document/GetDesignatedPersonsForSelect?ids=' + recipient_designated_person_ids,
                                (res) => {

                                    if(res.data.length > 0) { 
                                        this.document.recipient_multiple_designated_person = [{}]       
                                    } else {
                                        this.document.recipient_multiple_designated_person = []
                                    }
                                    
                                    res.data.forEach((element) => {
                                        this.document.recipient_multiple_designated_person.push(element)
                                    });
                                },
                                this.handleError, true);
                        }
                    }
                }

                if (formDataObj != null) {
                    if (formDataObj.documentDate != '')
                        this.document.date = formDataObj.documentDate

                    this.document.translatedSubject = formDataObj.translatedSubject
                    if (formDataObj.translatedSubject != '')
                        this.showTranslatedSubjectBlock = true

                    this.document.keywords = formDataObj.keywords
                    if (formDataObj.keywords != '')
                        this.showKeywordsBlock = true

                    this.document.otherAttachments = formDataObj.otherAttachments
                    if (formDataObj.otherAttachments != '')
                        this.showOtherAttachmentsBlock = true

                    this.documentSignersBackup = formDataObj.signers
                    this.document.send_after_sign = formDataObj.sendAfterSign

                    if (formDataObj.templateId != '')
                        this.getTemplateDescription(formDataObj.templateId, JSON.parse(formDataObj.signers))

                    // for ADFD
                    this.document.outputGroup = formDataObj.outputGroup
                    this.document.output = formDataObj.output
                    if (formDataObj.country != null && formDataObj.country != undefined)
                    {
                        var country = constants.countriesList.find(x => x.Id == formDataObj.country)
                        if (country != null && country != undefined)
                            this.document.country = country
                    }
                    if (formDataObj.project != null && formDataObj.project != undefined)
                    {
                        var project = constants.projectsList.find(x => x.Id == formDataObj.project)
                        if (project != null && project != undefined)
                            this.document.project = project
                    }
                }

                this.document.canSign = item.canSign 
                this.document.isRegistered = item.isRegistered
                this.document.cCed = item.cCed

                if (this.document.cc && this.document.cc.length > 1) {
                    this.showCCBlock = true;
                }

                window.documentView.document = this.document
            },
            getDocumentWithTransfer() {
                axios.get(constants.baseApiUrl + 'Transfer/GetDocumentTransferInfo?documentId='+this.documentId+'&transferId=' + this.transferId + '&delegationId=' + this.delegationId)
                .then(response => 
                {
                    //
                    this.document = utils.copyObject(response.data[0], this.document)

                    var receivingEntitiesObjects = JSON.parse(this.document.receivingEntities);
                    this.subject = this.document.subject
                    var documentForm = JSON.parse(this.document.formData);
                    if(documentForm && documentForm.signers && documentForm.signers != null)             
                    {
                        this.documentSignersBackup = JSON.stringify(JSON.parse(this.document.formData).signers)
                        this.document.signers = JSON.parse(JSON.parse(this.document.formData).signers);
                    }
                    
                     if (response.data[0] != null && response.data[0].sendingEntity != undefined) {
                        this.document.SendingEntity = JSON.parse(response.data[0].sendingEntity)
                    }   
                  
                    if (this.document.receivingEntities != null && this.document.receivingEntities != undefined && this.document.receivingEntities.length > 0) {
                        var receivingEntitiesObjects = JSON.parse(this.document.receivingEntities)

                        var recipientItems = [{}]
                        receivingEntitiesObjects.forEach(function (recipient) {
                        recipientItems.push({ id: recipient.id.toString(), name: recipient.text, isUser: false, external: recipient.external })
                        });
                        if (this.document.categoryId == 1) {
                            if (recipientItems.length > 1) { 
                                this.document.recipient_single = recipientItems[1]
                            }
                        }
                        else 
                        {
                            this.document.recipient_multiple = recipientItems
                        }
                    }               
                    window.documentView.document = this.document 
                    if (this.viewMode == 'edit_new') {
                        axios.post(constants.baseApiUrl + 'Transfer/MarkTransferAsRead?transferId=' + this.transferId + '&delegationId=' + this.delegationId, null)
                        .then(response => { console.log('MarkedTransferAsRead') })
                        .catch(error => console.log(error));
                    }
                    this.fillDocumentDataForEdit(response.data[0]);

                    var context = this;
                    setTimeout(() => {
                        if(context.$refs.transferNotesIcon){
                            this.$refs.transferNotesIcon.showTransferNotes(this.document.fromUserId, this.document.instruction);
                        }
                    }, 50);
                })
                .catch(error => console.log(error))
            },
            documentSenderSelectedChange(item)
            {
                //to solve reactivity issue
                this.$set(this.document, 'sender', item);
                this.document.sender_designated_person = {}
                console.log(this.document);
            },
            documentRecipientMultipleSelectedChange(items)
            {
                this.$set(this.document, 'recipient_multiple', this.handleFirstElement(items));
                this.document.recipient_multiple_designated_person = [];
                console.log(this.document);
            },
            handleFirstElement(data, tempItem)
            {
                if(data.length > 0) {
                    var shouldAddTemp = true;
                    for (var i = 0; i<data.length; i++){
                        if(data[i].isTemp 
                            || data[i].id == undefined 
                            || data[i].id == null){
                                shouldAddTemp = false;
                                break;
                        }
                    }
                    if(shouldAddTemp) {
                        if(tempItem == undefined || tempItem == null){
                            tempItem = {isTemp: true, name: 'temp'};
                        }
                        data = [tempItem, ...data];
                    } else if(data.length == 1){
                        data = [];
                    }
                }
                return data;
            },
            applyChanges() 
            {
                if (this.isFormValid()) {
                    //
                    if (JSON.stringify(this.document.signers) != this.documentSignersBackup && this.document.categoryId != 1) {
                        window.showInformation(this.$t('res_Label_Alert'),this.$t('res_Msgs_preconfiguredSignatuesAlert'),
                            () => { this.SaveDocumentCallApi() },
                            () => { })
                    }
                    else {
                        //
                        this.SaveDocumentCallApi();
                    }
                }
            },
            isFormValid() 
            {
                var retVal = true

                if (this.user_structure == null || this.user_structure == undefined || this.user_structure.structureId == null || this.user_structure.structureId == undefined) 
                {
                    retVal = false
                }

                //
                if (this.document.sender == null || this.document.sender == undefined || this.document.sender.id == null || this.document.sender.id == undefined)
                    retVal = false

                // validate recipient
                if (this.document.categoryId == 1) 
                {
                    var item = this.document.recipient_single
                    if (item == null || item == undefined || item.id == null || item.id == undefined)
                        retVal = false
                }
                else 
                {
                    if (this.document.recipient_multiple.length <= 1)
                        retVal = false
                    else 
                    {
                        var items = this.document.recipient_multiple
                        for (var i = 1; i < items.length; i++) 
                        {
                            var item = items[i];
                            if (item == null || item == undefined || item.id == null || item.id == undefined)
                                continue;
                        }
                    }
                }

                if (this.document.priority == null || this.document.priority.id == undefined)
                    retVal = false

                if (this.document.privacy == null || this.document.privacy.id == undefined)
                    retVal = false

                if (this.document.date == null || this.document.date == undefined || this.document.date == '')
                    retVal = false

                if (this.document.subject == null || this.document.subject == undefined || this.document.subject == '')
                    retVal = false
                else 
                {
                    if (this.document.subject.length > 350) 
                    {
                        window.showAlert("Subject field can't be more than 350 characters", 'warning')
                        return false
                    }
                }

                if (this.document.categoryId == 1)
                    if (this.document.externalReferenceNumber == null || this.document.externalReferenceNumber == undefined || this.document.externalReferenceNumber == '')
                        retVal = false

                if (this.document.categoryId == 3 && this.selectedTemplate.isWorkflow == true) 
                {
                    if (this.document.signers == null || this.document.signers == undefined || this.document.signers.length == 0)
                        retVal = false
                    else 
                    {
                        this.document.signers.forEach(element => 
                        {
                            if (element == undefined || element.name == undefined || element.name == '')
                                retVal = false
                        });
                    }
                }

                if (retVal == false) 
                {
                    window.showAlert('res_Msgs_FillRequired', 'warning')
                }

                return retVal;
            },
            SaveDocumentCallApi() 
            {
                //
                var model = this.prepareFormDataObject(true)

                window.showLoading()
                axios.post(constants.baseApiUrl + 'Document/Save', model)
                    .then(res => {
                        if (res == undefined || res.data == null) {
                            window.hideLoading();
                            window.showAlert('res_Msgs_ErrorOccured', 'error')
                        }
                        else if (res.data == "ExternalReferencedNumberInUse") {
                            window.hideLoading();
                            window.showAlert("res_Msgs_SameLetterExist", "warning")
                        }
                        else if (res.data == "OriginalFileInUse") {
                            window.hideLoading();
                            window.showAlert("res_Msgs_ErrorFileCheckedOut", "warning")
                        }
                        else {
                            axios.get(constants.baseApiUrl + 'Document/save-custom?documentId=' + this.documentId)
                                .then(res => {
                                    if (res == undefined || res.data == null) {
                                        window.hideLoading();
                                        window.showAlert('res_Msgs_ErrorOccured', 'error')
                                    }
                                    else {
                                        window.showAlert('res_Msgs_DocumentSavedSuccess', 'success')
                                        this.getDocumentWithTransfer()
                                    }
                                })
                                .catch(error => console.log(error))
                                .finally(() => window.hideLoading())
                        }
                    })
                    .catch(err => { this.handleError(err); window.hideLoading(); })
            },
            prepareFormDataObject(isRegister) 
            {
                //
                var templateId = '';

                if (this.document.formData != undefined) {
                    var formDataObj = JSON.parse(this.document.formData);
                    if (formDataObj != null && formDataObj.templateId != undefined)
                        templateId = formDataObj.templateId;
                }

                var recipient_designated_person_ids = '';
                if (this.document.categoryId == 1) {
                    if (this.document.recipient_single_designated_person != undefined && this.document.recipient_single_designated_person != null)
                        recipient_designated_person_ids = this.document.recipient_single_designated_person.id
                }
                else {
                    if (this.document.recipient_multiple_designated_person != undefined && this.document.recipient_multiple_designated_person != null) {
                        this.document.recipient_multiple_designated_person.forEach(function (item) {
                            if (item != undefined && item != null && item.id != undefined && item.id != null)
                                recipient_designated_person_ids += item.id + ','
                        });
                    }
                }

                var sender_designated_person_ids = '';
                if (this.document.sender_designated_person != undefined && this.document.sender_designated_person != null)
                    sender_designated_person_ids = this.document.sender_designated_person.id

                if (this.document.signers != null && this.document.signers != undefined && this.document.signers.length > 0)
                    this.document.signers.forEach((item) => {
                        item.index = this.document.signers.indexOf(item) + 1
                    });


                var model = new FormData();
                model.append('id', this.documentId);
                model.append('categoryId', this.document.categoryId);
                model.append('subject', this.document.subject);
                model.append('formData', JSON.stringify({
                    "senderDesignatedPerson": sender_designated_person_ids,
                    "recipientDesignatedPerson": recipient_designated_person_ids,
                    "translatedSubject": this.document.translatedSubject,
                    "keywords": this.document.keywords,
                    "otherAttachments": this.document.otherAttachments,
                    "templateId": templateId,
                    "signers": JSON.stringify(this.document.signers),
                    "documentDate": this.document.date,
                    "outputGroup": this.document.outputGroup,
                    "output": this.document.output,
                    "country": this.document.country.Id,
                    "project": this.document.project.Id,
                    "sendAfterSign":this.document.send_after_sign

                }));

                if (this.document.categoryId == 1) {
                    if (this.document.recipient_single != null && this.document.recipient_single != undefined) {
                        if (this.document.recipient_single.id != null && this.document.recipient_single.id != undefined) {
                            model.append('receivers[0][Id]', this.document.recipient_single.id);
                            model.append('receivers[0][IsEntityGroup]', false);
                        }
                    }
                }
                else {
                    if (this.document.recipient_multiple != null && this.document.recipient_multiple != undefined) {
                        for (var i = 1; i < this.document.recipient_multiple.length; i++) {
                            var item = this.document.recipient_multiple[i];
                            if (item == null || item == undefined || item.id == null || item.id == undefined)
                                continue;
                            model.append('receivers[' + (i - 1) + '][Id]', item.id);
                            model.append('receivers[' + (i - 1) + '][IsEntityGroup]', false);
                        }
                    }
                }

                if (this.document.sender != null && this.document.sender != undefined && this.document.sender.id != null && this.document.sender.id != undefined) {
                    model.append('sendingEntityId', this.document.sender.id);
                }

                if (this.document.dueDate != null && this.document.dueDate != undefined && this.document.dueDate != '')
                    model.append('dueDate', this.document.dueDate);
                else
                    model.append('dueDate', '');

                model.append('priorityId', this.document.priority.id);
                model.append('privacyId', this.document.privacy.id);
                if(this.document.importance.id){
                    model.append('importanceId',   this.document.importance.id);
                }
                model.append('classificationId', '');
                model.append('documentTypeId', '');
                if (this.document.cc != null && this.document.cc != undefined) {
                    this.document.cc.forEach(element => {
                        if (element != null && element != undefined && element.id != null && element.id != undefined)
                            model.append('carbonCopy[]', element.id);
                    });
                }
                model.append('register', isRegister);
                model.append('createdByStructureId', this.user_structure.structureId);
                model.append('externalReferenceNumber', this.document.externalReferenceNumber);
                model.append('transferId', '');
                return model
            },
            getLookupItems() 
            {
                this.priority_items = constants.priorities
                this.privacy_items = constants.privacies
                this.importance_items = constants.importancies

                this.document.priority = this.priority_items[0]
                this.document.privacy = this.privacy_items[0]
                this.document.importance = this.importance_items[0]
            },
            getTemplateDescription(templateId, signersList) 
            {
                this.selectedTemplate = null
                window.documentView.template_signatureCount = 0
                window.documentView.template_signersList = []
                utils.defaultGet('Template/GetTemplateDescription?Id=' + templateId, (res) => 
                {
                    if (res.data != null && res.data != undefined) 
                    {
                        this.selectedTemplate = res.data

                        // for adfd
                        if (constants.client_version_Id == 'ADFD') 
                        {
                            if (this.selectedTemplate.form != null && this.selectedTemplate.form != undefined && this.selectedTemplate.form != '')
                            {
                                var templateJson = JSON.parse(this.selectedTemplate.form);
                                this.showProjectGroup = templateJson.showProjectGroup
                            }
                            else
                                this.showProjectGroup = false
                        }

                        window.documentView.template_isWorkflow = this.selectedTemplate.isWorkflow

                        if ((this.document.categoryId == 3 && this.selectedTemplate.isWorkflow == true) || (constants.client_version_Id="DDA")) 
                        {
                            if (signersList == null || signersList == undefined || signersList.length == 0) 
                            {
                                // check if you have predefined signers
                                var predefinedSigners = this.selectedTemplate.signatoryList
                                if (predefinedSigners != null && predefinedSigners != undefined && predefinedSigners != '') 
                                {
                                    var signatoryUserIds = ''
                                    var signatoryList = predefinedSigners.split('|').filter(e => e);
                                    for (var i = 0; i < signatoryList.length; i++) 
                                    {
                                        signatoryUserIds += "'" + signatoryList[i].split('#')[0] + "',"
                                    }

                                    // remove last comma if exists
                                    if (signatoryUserIds.endsWith(','))
                                        signatoryUserIds = signatoryUserIds.substring(0, signatoryUserIds.length - 1)

                                    utils.defaultGet('StructureUser/GetUsersForMultiSelect?userIds=' + signatoryUserIds, (res) => {
                                        if (res != undefined && res.data != null && res.data != undefined) {
                                            this.document.signers = res.data
                                            if (res.data.length == this.selectedTemplate.signatureCount)
                                                this.signerSelectionEnabled = false
                                            else {
                                                var predefinedSignersCount = res.data.length
                                                for (var i = 0; i < this.selectedTemplate.signatureCount - predefinedSignersCount; i++)
                                                    this.document.signers.push({ index: res.data.length + i + 1 })
                                            }
                                            window.documentView.template_signersList = this.document.signers
                                        }
                                    }, this.handleError, true);
                                }
                                else {
                                    for (var i = 0; i < this.selectedTemplate.signatureCount; i++)
                                        this.document.signers.push({ index: i + 1 })

                                    this.signerSelectionEnabled = true
                                }
                            }
                            else {
                                this.document.signers = signersList
                                window.documentView.template_signersList = signersList

                                this.signerSelectionEnabled = true
                                if (this.splitAndRemoveEmpty(this.selectedTemplate.signatoryList, '|').length == signersList.length)
                                    this.signerSelectionEnabled = false
                            }
                        }

                        window.documentView.template_signatureCount = this.selectedTemplate.signatureCount
                    }
                },
                    this.handleError, true);
            },
            splitAndRemoveEmpty(input, delimiter) {
                if(input == null){
                    return [];
                }
                const filteredParts = input.split(delimiter).filter(part => part.trim() !== '');
                return filteredParts;
            },
            getUserStructures()
            {
                axios.post(constants.baseApiUrl + 'StructureUser/GetCurrentUserStructures', null)
                    .then(response => {
                        this.user_structures = response.data;
                        if (this.user_structures.length > 0)
                            this.user_structure = this.user_structures[0] 
                    })
                    .catch(error => console.log(error))
                    .finally(() => this.loading = false);
            },
            async fixSign(documentId, enableMultiPageSplit = false)
            {
                window.showLoading();
                try {
                    const res = await axios.post(constants.baseApiUrl + 'Admin/FixSignedDocument?documentId=' + documentId + '&enableMultiPageSplit=' + enableMultiPageSplit);
                    if (res.data == 1) {
                        window.showAlert('res_Msgs_FixSignatureSuccess', 'success')
                        this.searchCorrepondences()
                        this.closePreview()
                    }
                    else {
                        window.showAlert('res_Msgs_ErrorOccured', 'error')
                    }
                } catch (err) {
                    console.warn(err);
                } finally {
                    window.hideLoading();
                }
            },
            backToAdminPage(){
                router.push({ name: 'admin' })
            }
        },
        mounted() 
        {
            this.prepareStatusForSelect();
            this.getLookupItems();
            this.getUserStructures();
            this.window = window;
            this.enableAdminPreviewCorrespondence = this.window.enableAdminPreviewCorrespondence;
        },
        watch:
        {
            'document.date': function () 
            {
                if (this.document.date != null && this.document.date != '' && this.document.date != undefined)
                    this.formattedDate = utils.dateFormat(this.document.date)
                else
                {
                    this.document.date = new Date().toISOString().slice(0, 10)
                    this.formattedDate = utils.dateFormat(new Date().toISOString().slice(0, 10))
                }
            },
            'document.dueDate': function () {
                this.formattedDueDate = utils.dateFormat(this.document.dueDate)
            },
            documentId(){
                this.getUserStructures()
            }
        }
    }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css">
</style>